import { RouteConfig } from 'config/constants/route'
import { ActionQueryEnum } from 'hooks/useActionQueryListener'
import useMatchBreakpoints from 'hooks/useMatchBreakpoints'
import { memo } from 'react'
import { Trans } from 'react-i18next'
import styled from 'styled-components'
import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import Grid from 'UIKit/Box/Grid'
import Link from 'UIKit/Link'
import Text from 'UIKit/Text'
import MenuFooterExpand from '../Menu/MenuFooterExpand'

const listLink = [
  {
    menu: {
      content: 'PRODUCTS',
    },
    subMenus: [
      {
        content: 'HunnyPoker',
        to: RouteConfig.HunnyPoker,
        isExternal: true,
        id: 'hunny-poker',
        attributes: {
          rel: 'nofollow',
        },
      },
      {
        content: 'HunnySwap',
        to: RouteConfig.HunnySwap,
        isExternal: true,
        id: 'hunny-swap',
        attributes: {
          rel: 'nofollow',
        },
      },
      {
        content: 'Farm',
        to: RouteConfig.HunnyFarm,
        isExternal: true,
        id: 'farm',
        attributes: {
          rel: 'nofollow',
        },
      },
    ],
  },
  {
    menu: {
      content: 'FEATURES',
    },
    subMenus: [
      {
        content: 'Staking',
        to: RouteConfig.Stake,
        isExternal: false,
        id: 'desktop-staking',
      },
      {
        content: 'Cashback',
        to: RouteConfig.Cashback,
        isExternal: false,
        id: 'cashback',
      },
      {
        content: 'Bonus (HUSD)',
        to: `?action=${ActionQueryEnum.UnlockHUSD}`,
        id: 'bonus-husd',
      },
      {
        content: 'VIP Benefit',
        to: `?action=${ActionQueryEnum.OpenAllLevel}`,
        id: 'vip-benefit',
      },
      {
        content: 'Earn Referral',
        to: RouteConfig.Referral,
        id: 'earn-referral',
      },
    ],
  },
  {
    menu: {
      content: 'PROMO',
    },
    subMenus: [
      {
        content: 'Hot Promotions',
        to: RouteConfig.Promotions,
        isExternal: false,
        id: 'hot-promotion',
      },
      {
        content: 'Promo Materials',
        to: RouteConfig.PromotionMaterials,
        isExternal: true,
        id: 'promo-material',
        attributes: {
          rel: 'nofollow',
        },
      },
    ],
  },
  {
    menu: {
      content: 'HELP',
    },
    subMenus: [
      {
        content: 'Term of Service',
        to: RouteConfig.TermOfService,
        isExternal: true,
        id: 'term-of-service',
      },
      {
        content: 'Gambling Hub',
        to: RouteConfig.Blogs,
        isExternal: true,
        id: 'gambling-hub',
      },
      {
        content: 'Documents',
        to: RouteConfig.HunnyDocs,
        isExternal: true,
        id: 'documents',
        attributes: {
          rel: 'nofollow',
        },
      },
    ],
  },
]

const OverviewInfoMobile = () => {
  return (
    <Box width={'100%'}>
      {listLink.map((link, menuIndex) => (
        <MenuFooterExpand
          key={`menu-link-footer-mobile-${menuIndex}`}
          menu={link.menu}
          subMenus={link.subMenus}
          menuHeight={30}
        />
      ))}
    </Box>
  )
}

const OverviewInfoDesktop = () => {
  return (
    <WrapColLink>
      {listLink.map((link, index) => (
        <StyleWrapLink key={`footer-nav-col-link${index}`}>
          <Text width="max-content" fontSize="12px" color="text" fontWeight="bold" letterSpacing="0.1em" mb="6px">
            <Trans>{link.menu.content}</Trans>
          </Text>
          {link.subMenus.map((subMenu) => {
            return (
              <Link
                external={subMenu.isExternal}
                title={subMenu.content}
                id={subMenu.id}
                width="max-content !important"
                fontSize="12px"
                my="6px"
                color="textTertiary"
                key={`footer-link-nav-col-link${subMenu.id}`}
                href={subMenu.to || ''}
                {...(subMenu?.attributes || {})}
              >
                <Trans>{subMenu.content}</Trans>
              </Link>
            )
          })}
        </StyleWrapLink>
      ))}
    </WrapColLink>
  )
}
const OverviewInformation = () => {
  const { isTablet, isDesktop } = useMatchBreakpoints()

  return <>{isTablet || isDesktop ? <OverviewInfoDesktop /> : <OverviewInfoMobile />}</>
}

const WrapColLink = styled(Grid)`
  width: 85%;
  gap: 0 40px;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  align-items: flex-start;

  ${({ theme }) => theme.mediaQueries.sm} {
    width: 100%;
  }

  ${({ theme }) => theme.mediaQueries.xl} {
    width: 50%;
    gap: 0 20px;
  }
`

const StyleWrapLink = styled(Flex)`
  width: calc(33% - 80px);
  flex-direction: column;
  justify-content: flex-end;
`

export default memo(OverviewInformation)
